import cx from 'classnames'

import './style.scss'

type BadgeProps = {
  label: string
  theme?: 'primary' | 'official' | 'admin'
  className?: string
  onClick?: () => {}
}

const Badge = ({
  label,
  theme = 'primary',
  className,
  onClick,
}: BadgeProps) => {
  return (
    <span
      className={cx(
        'Badge',
        `Badge--theme-${theme}`,
        onClick && 'Badge--selectable',
        className
      )}
      onClick={onClick}
    >
      {label}
    </span>
  )
}

export default Badge
